
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="soft-tissue-pin-close-container">
        <div class="header-container-new-soft-tissue-pin">
            <span><img src="../../assets/icons/soft_tissue_pin.png" alt="New Pin Icon" class="new-soft-tissue-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-soft-tissue-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.SOFT-TISSUE-TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="soft-tissue-pin-info-container">

        <div class="soft-tissue-pin-container">
            <div class="soft-tissue-pin-headers">
                <p class="soft-tissue-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
                <p class="soft-tissue-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
                <p class="soft-tissue-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
                <p class="soft-tissue-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
                <p class="soft-tissue-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
                <p class="soft-tissue-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
            </div>

        </div>

        <div class="soft-tissue-pin-container">
            <ng-container>
                <p class="soil-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="soil-pin-info-text">{{pinObj.lat}}</p>
                <p class="soil-pin-info-text">{{pinObj.lng}}</p>
                <p class="soil-pin-info-text">{{pinObj.farm}}</p>
                <p class="soil-pin-info-text">{{pinObj.field}}</p>
                <p class="soil-pin-info-text">{{pinObj.creatingUser}}</p>
            </ng-container>

        </div>
    </div>
    <div class="soft-tissue-pin-delete-btn-container">
        <button class="delete-soft-tissue-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
            <div class="soft-tissue-pin-btn-content">
                <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-soft-tissue-pin-btn-icon">
                <span><p class="soft-tissue-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
            </div>
        </button>
    </div>

    <mat-divider></mat-divider>

    <div class="header-container-new-soft-tissue-pin samples-header">
        <h1 mat-dialog-title  class="new-soft-tissue-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.SAMPLES-TITLE' | translate }}</h1>
    </div>

    <div class="soft-tissue-sample-list-container">
        <mat-card class="soft-tissue-pin-item-card"  *ngFor="let sampleItem of samples">
            <div class="soft-tissue-sample-content-container">

                <div class="soft-tissue-sample-text-container">
                    <!-- Sample, group and bag number stay on one line and wrap together once the text
                         outgrows the dialog, rather than each claiming a row of its own. -->
                    <div class="sample-name-text-container">
                        <span class="sample-inline-field">
                            <p class="soft-tissue-sample-item-bold-text">{{ 'NEW-PIN-TYPE-DIALOG.SAMPLE' | translate }}:</p>
                            <p class="soft-tissue-sample-details-text">{{sampleItem.name}}</p>
                        </span>
                        <span class="sample-inline-field sample-inline-field--sep">
                            <p class="soft-tissue-sample-item-bold-text">{{ 'NEW-PIN-TYPE-DIALOG.LINKED-GROUP' | translate }}:</p>
                            <p class="soft-tissue-sample-details-text">{{sampleItem.group.name}}</p>
                        </span>
                        <span class="sample-inline-field sample-inline-field--sep" *ngIf="sampleItem.bagNumber">
                            <p class="soft-tissue-sample-item-bold-text">{{ 'ADD-EDIT-NEW-SAMPLE-DIALOG.BAG-NUMBER' | translate }}:</p>
                            <p class="soft-tissue-sample-details-text">{{sampleItem.bagNumber}}</p>
                        </span>
                    </div>
                    <div class="sample-name-text-container">
                        <p class="soft-tissue-sample-item-bold-text" style="font-size: 10px;">{{ 'NEW-PIN-TYPE-DIALOG.CREATED-DATE' | translate }}:</p><p class="soft-tissue-sample-details-text" style="font-size: 10px;">{{sampleItem.creationDate | date: 'yyyy-MM-dd, hh:mm:ss'}}</p>
                    </div>
                </div>
                <div class="soft-tissue-sample-btn-container">

                    @if (sampleItem?.isCompleted) {
                        <mat-icon>done</mat-icon>
                    }

                    <button class="delete-soft-tissue-sample-small-btn" mat-flat-button type="button" (click)="openDeleteSampleDialog(sampleItem)">
                        <div class="soft-tissue-sample-item-content">
                            <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-soft-tissue-pin-btn-icon">
                        </div>
                    </button>

                    <button class="edit-soft-tissue-sample-small-btn" mat-flat-button type="button" (click)="openEditSampleDialog(sampleItem)">
                        <div class="soft-tissue-sample-item-content">
                            <img src="../../assets/icons/edit.svg" alt="Edit Icon" class="new-soft-tissue-pin-btn-icon">
                        </div>
                    </button>
                </div>
            </div>
        </mat-card>
    </div>

    <button class="add-sample-soft-tissue-pin-btn" mat-flat-button type="button" (click)="openAddSampleDialog()">
        <div class="soft-tissue-pin-btn-content">
            <img src="../../assets/icons/add_icon.svg" alt="Attach Icon" class="new-soft-tissue-pin-btn-icon">
            <span><p class="soft-tissue-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.ADD-SAMPLE' | translate }}</p></span>
        </div>
    </button>
</div>


